module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/b5a010c5cfdd5526e177a8330beae1d5.png";